function _s(o, i, p, l) {
  void 0 === i && (i = 400);
  void 0 === l && (l = !1);

  o.style.overflow = "hidden";
  l && (o.style.display = "block");

  var n,
    t = window.getComputedStyle(o),
    s = parseFloat(t.getPropertyValue("height")),
    a = parseFloat(t.getPropertyValue("padding-top")),
    r = parseFloat(t.getPropertyValue("padding-bottom")),
    y = parseFloat(t.getPropertyValue("margin-top")),
    d = parseFloat(t.getPropertyValue("margin-bottom")),
    g = s / i,
    m = a / i,
    h = r / i,
    u = y / i,
    x = d / i;

  window.requestAnimationFrame(function t(e) {
    void 0 === n && (n = e);
    e -= n;

    if (l) {
      o.style.height = g * e + "px";
      o.style.paddingTop = m * e + "px";
      o.style.paddingBottom = h * e + "px";
      o.style.marginTop = u * e + "px";
      o.style.marginBottom = x * e + "px";
    } else {
      o.style.height = s - g * e + "px";
      o.style.paddingTop = a - m * e + "px";
      o.style.paddingBottom = r - h * e + "px";
      o.style.marginTop = y - u * e + "px";
      o.style.marginBottom = d - x * e + "px";
    }

    if (i <= e) {
      o.style.height = "";
      o.style.paddingTop = "";
      o.style.paddingBottom = "";
      o.style.marginTop = "";
      o.style.marginBottom = "";
      o.style.overflow = "";

      if (!l) o.style.display = "none";
      if (typeof p === "function") p();
    } else {
      window.requestAnimationFrame(t);
    }
  });
}

HTMLElement.prototype.slideToggle = function (t, e) {
  0 === this.clientHeight ? _s(this, t, e, !0) : _s(this, t, e);
};

HTMLElement.prototype.slideUp = function (t, e) {
  _s(this, t, e);
};

HTMLElement.prototype.slideDown = function (t, e) {
  _s(this, t, e, !0);
};

class ProductGrid extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.init();
  }

  init() {
    // Gestion des boutons de catégorie
    this.querySelectorAll(".white-button").forEach((elem) => {
      elem.addEventListener("click", this.toggleCollection.bind(this));
    });

    // Gestion des boutons "Acheter"
    this.querySelectorAll(".buy-button").forEach((button) => {
      button.addEventListener("click", this.addToCart.bind(this));
    });

    // Initialisation Swiper
    this.swiper = new Swiper(this.querySelector(".swiper"), {
      direction: "horizontal",
      loop: false,
      spaceBetween: 18,
      slidesOffsetBefore: 14,
      slidesPerView: 1.9,
      breakpoints: {
        990: {
          spaceBetween: 18,
          slidesOffsetBefore: 0,
          slidesPerView: 4,
        },
      },
    });
  }

  toggleCollection(event) {
    const buttonId = event.target.getAttribute("data-id");
    const swiperWrapper = this.querySelector(".swiper-wrapper");

    // Masquer toutes les cartes produits
    swiperWrapper.querySelectorAll("[data-block-id]").forEach((productList) => {
      const blockId = productList.dataset.blockId;
      if (blockId === buttonId) {
        productList.classList.remove("hidden"); // Afficher la liste correspondante
      } else {
        productList.classList.add("hidden"); // Masquer les autres
      }
    });

    // Mettre à jour les classes actives sur les boutons de catégorie
    this.querySelectorAll(".white-button").forEach((button) => {
      button.classList.toggle(
        "active-button-grid",
        button.getAttribute("data-id") === buttonId
      );
    });
  }

  addToCart(event) {
    document.querySelector('.loader-side-cart').classList.add('loading')
    event.stopPropagation(); // Empêche la propagation du clic vers d'autres gestionnaires

    const variantId = event.target.getAttribute("data-variant-id");
    const quantity = 1;

    // Vérifier si le produit est déjà dans le panier
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        // Chercher si le produit est déjà dans le panier
        const existingItem = cart.items.find(
          (item) => item.variant_id === parseInt(variantId)
        );

        if (existingItem) {
          // Si l'article existe déjà, on met à jour la quantité
          this.updateQuantity(
            existingItem.id,
            existingItem.quantity + quantity
          );
        } else {
          // Sinon, on l'ajoute au panier
          this.addProductToCart(variantId, quantity);
        }
      })
      .catch((error) => {
        console.error("Erreur lors de la récupération du panier:", error);
      });
  }

  addProductToCart(variantId, quantity) {
    document.querySelector('.loader-side-cart').classList.add('loading')
    // Requête AJAX pour ajouter au panier
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Produit ajouté au panier:", data);

        // Rafraîchir le panier immédiatement après l'ajout du produit
        this.updateCart();
      })
      .catch((error) => {
        console.error("Erreur lors de l'ajout au panier:", error);
      });
  }

  updateQuantity(itemId, newQuantity) {
    document.querySelector('.loader-side-cart').classList.add('loading')
    // Requête AJAX pour mettre à jour la quantité d'un article existant
    fetch(`/cart/update.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        updates: {
          [itemId]: newQuantity,
        },
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Quantité mise à jour dans le panier:", data);

        // Rafraîchir le panier immédiatement après la mise à jour
        this.updateCart();
      })
      .catch((error) => {
        console.error("Erreur lors de la mise à jour du panier:", error);
      });
  }

  async updateCart() {
    document.querySelector('.loader-side-cart').classList.add('loading')
    const url = `${window.Shopify.routes.root}?section_id=side-cart`;

    try {
      const response = await fetch(url);
      const html = await response.text();

      const currentCart = document.querySelector("#section-side-cart");
      const wasActive = currentCart.classList.contains("active-sc");

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      const newCart = doc.querySelector("#section-side-cart");
      newCart.querySelector("side-cart").classList.add("active-sc");

      if (currentCart && newCart) {
        currentCart.innerHTML = newCart.innerHTML;

        // Restaurer l'état actif si nécessaire
        if (wasActive) {
          currentCart.classList.add("active-sc");
        }
      }

      const overlay = document.querySelector(".overlay");
      if (overlay) {
        overlay.classList.add("overlay-blur");
      }

      console.log("Panier mis à jour avec succès !");
    } catch (error) {
      console.error("Erreur lors du rendu du panier :", error);
    }
  }
}

customElements.define("product-grid", ProductGrid);

class SectionVideo extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.querySelectorAll(".play-icon-video").forEach((playButton) => {
      playButton.addEventListener("click", (e) => {
        console.log("Vous avez cliqué sur le bouton Play");
        const overlaySection = e.target.closest(".left-video");
        const videoSection = overlaySection.querySelector("video");
        console.log(videoSection);
        console.log(overlaySection);

        overlaySection.querySelector(
          ".video-thumbnail-section-image"
        ).style.display = "none";
        playButton.style.display = "none";

        videoSection.style.display = "block";
        videoSection.setAttribute("controls", true);
        videoSection.play();
      });
    });
  }
}

customElements.define("section-video", SectionVideo);

class TabsSection extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.init();

    const firstCategorySection = document.querySelector(
      "[data-category-section]:first-of-type"
    );
    if (firstCategorySection) {
      firstCategorySection.style.display = "block";
      const firstCategory = firstCategorySection.getAttribute(
        "data-category-section"
      );
      const firstButton = document.querySelector(
        `[data-category-open="${firstCategory}"]`
      );
      if (firstButton) firstButton.classList.add("active-faq"); // Ajoute la classe active
    }

    // Cache les réponses des FAQ au chargement
    this.querySelectorAll(".faq-item-text").forEach((item) => {
      item.style.display = "none";
    });

    // Ajoute un écouteur pour chaque titre des FAQ
    this.querySelectorAll(".faq-item-title").forEach((button) => {
      button.addEventListener("click", this.toggleFaqItem.bind(this));
    });

    // Ajoute un écouteur pour chaque catégorie de boutons
    this.querySelectorAll("[data-category-open]").forEach((category) => {
      category.addEventListener("click", this.switchCategorie.bind(this));
    });

    const buttons = this.querySelectorAll(".category-button-faq");
    buttons.forEach((button) => {
      button.addEventListener("click", this.toggleActiveButton.bind(this));
    });

    this.on_process = false;
  }

  toggleActiveButton(e) {
    // Supprime la classe active de tous les boutons
    this.querySelectorAll(".category-button-faq").forEach((button) => {
      button.classList.remove("active-faq");
    });
    e.currentTarget.classList.add("active-faq"); 

    // Ajoute la classe active au bouton cliqué
    e.currentTarget.classList.add("active-faq");
  }

  toggleFaqItem(e) {
    e.stopPropagation();
    if (this.on_process == false) {
      this.on_process = true;

      const currentItem = e.currentTarget.parentNode; // Élément cliqué
      const allItems = document.querySelectorAll(".faq-item-active"); // Tous les items ouverts

      // Ferme les autres éléments déjà ouverts
      allItems.forEach((item) => {
        if (item !== currentItem) {
          item.classList.remove("faq-item-active");
          item.querySelector('.faq-item-text').slideUp(250);
        }
      });

      const item = currentItem.querySelector(".faq-item-text");
      item.closest(".tabs-section__item").classList.toggle("faq-item-active");
      item.slideToggle(250);


      setTimeout(() => {
        this.on_process = false;
      }, 400);
    }
  }

  switchCategorie(e) {
    const category = e.currentTarget.getAttribute("data-category-open");

    const sectionToScrollTo = document.querySelector(
      `[data-category-section="${category}"]`
    );

    if (sectionToScrollTo) {
      const headerOffset = 140; 
      const elementPosition = sectionToScrollTo.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.scrollY - headerOffset;
  
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  }
  

  init() {
    this.swiper = new Swiper(this.querySelector(".swiper-button-faq"), {
      direction: "horizontal",
      loop: false,
      slidesPerView: "auto",
      spaceBetween: 8,
      slidesOffsetBefore: 20,
    });
  }
}

customElements.define("tabs-section", TabsSection);

class SwiperButtonCollapse extends HTMLElement {
  constructor() {
    super();

    const categoryButtons = this.querySelectorAll(".category-button");
    const faqItems = this.querySelectorAll(".faq-item");

    // Au chargement, on cache tous les faq items et on affiche ceux de la première catégorie
    faqItems.forEach(function (item) {
      item.style.display = "none";
    });

    // On affiche les items de la première catégorie
    const firstCategory = categoryButtons[0].getAttribute("data-category");
    categoryButtons[0].classList.add("active-faq"); // Assurez-vous que le premier bouton est actif
    
    
    faqItems.forEach(function (item) {
      if (item.getAttribute("data-category") === firstCategory) {
        item.style.display = "block"; // Affiche les éléments de la première catégorie
      }
    });

    // Gestion des clics sur les boutons de catégorie
    categoryButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        // Enlever la classe active de tous les boutons
        categoryButtons.forEach(function (btn) {
          btn.classList.remove("active-faq");
        });

        // Ajouter la classe active au bouton cliqué
        this.classList.add("active-faq");

        // Récupérer la catégorie de ce bouton
        const selectedCategory = this.getAttribute("data-category");

        // Afficher les faq items correspondant à la catégorie sélectionnée et cacher les autres
        faqItems.forEach(function (item) {
          if (item.getAttribute("data-category") === selectedCategory) {
            item.style.display = "block"; // Affiche l'élément
          } else {
            item.style.display = "none"; // Cache les autres éléments
          }
        });
      });
    });

    this.swiper = new Swiper(this.querySelector(".swiper-collapse"), {
      direction: "horizontal",
      loop: false,
      slidesPerView: "auto",
      slidesOffsetAfter: 40,
    });
  }
}
customElements.define("swiper-button-collapse", SwiperButtonCollapse);

class SideCart extends HTMLElement {
  constructor() {
    super();

    this.openButton = document.querySelectorAll("[data-open-cart]");
    this.closeButton = document.querySelectorAll("[data-close-cart]");
    this.deleteProduct = document.querySelectorAll(".delete-cart-perso");
    this.addButtonCart = document.querySelectorAll(
      ".button-buy-recommanded, .button-buy-sup"
    );
    this.sideCartBlur = document.querySelector(".overlay");
    this.Cart = document.querySelector("#section-side-cart");

    this.init();
  }

  init() {

    this.initSlider();
    
    this.openButton.forEach((elem) => {
      elem.addEventListener("click", this.openSideCart.bind(this));
    });

    this.closeButton.forEach((button) => {
      button.addEventListener("click", this.closeSideCart.bind(this));
    });

    this.deleteProduct.forEach((cart) => {
      cart.addEventListener("click", this.removeItem.bind(this));
    });

    this.addButtonCart.forEach((button) => {
      button.addEventListener("click", this.addToCart.bind(this));
    });

    document.querySelectorAll(".quantity-button-minus").forEach((button) => {
      button.addEventListener("click", this.decreaseQuantity.bind(this));
    });

    document.querySelectorAll(".quantity-button-plus").forEach((button) => {
      button.addEventListener("click", this.increaseQuantity.bind(this));
    });
  }

  initSlider(){
    this.swiper = new Swiper(this.querySelector(".swiper-product-sup"), {
      direction: "horizontal",
      loop: true,
      slidesPerView: 1,
      spaceBetween: 18,
      autoplay: {
        delay: 8000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      speed: 1000,
      navigation: {
        nextEl: ".side-cart__swiper-button-next",
        prevEl: ".side-cart__swiper-button-prev",
      },
    });
  }

  openSideCart() {
    this.classList.add("active-sc");
    document.body.classList.add("no-scroll");
    this.sideCartBlur.classList.add("overlay-blur");
    console.log("Panier ouvert");
  }

  closeSideCart() {
    this.classList.remove("active-sc");
    this.sideCartBlur.classList.remove("overlay-blur");
    document.body.classList.remove("no-scroll");
    console.log("Panier fermé");
  }

  async removeItem(event) {
    const itemId = event.currentTarget.dataset.id;

    if (!itemId) {
      console.error("ID de l'élément introuvable");
      return;
    }

    document.querySelector('.loader-side-cart').classList.add('loading')

    try {
      const formData = new FormData();
      formData.append("id", itemId);
      formData.append("quantity", 0);

      const response = await fetch("/cart/change.js", {
        method: "POST",
        body: formData,
      });

      const cart = await response.json();
      this.updateCart(cart);
    } catch (error) {
      console.error("Erreur lors de la suppression de l'article :", error);
    }
  }

  async addToCart(event) {
    document.querySelector('.loader-side-cart').classList.add('loading')
    const variantId = event.currentTarget.dataset.variantId;

    if (!variantId) {
      console.error("ID de variante introuvable");
      return;
    }

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });

      if (!response.ok) {
        throw new Error("Erreur lors de l'ajout au panier");
      }

      const cart = await response.json();
      this.updateCart(cart);
    } catch (error) {
      console.error("Erreur lors de l'ajout au panier :", error);
    }
  }

  async increaseQuantity(event) {
    document.querySelector('.loader-side-cart').classList.add('loading')
    const parentItem = event.currentTarget.closest(".cart-item__perso");
    if (!parentItem) {
      console.error("Erreur : Élément parent introuvable.");
      return;
    }

    const itemId = parentItem.dataset.id;
    const currentQuantity = parseInt(
      parentItem.querySelector(".span-quantity-perso").innerText
    );

    if (!itemId) {
      console.error("Erreur : ID du produit introuvable.");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("id", itemId);
      formData.append("quantity", currentQuantity + 1);

      const response = await fetch("/cart/change.js", {
        method: "POST",
        body: formData,
      });

      const cart = await response.json();
      this.updateCart(cart);
    } catch (error) {
      console.error("Erreur lors de l'augmentation de la quantité :", error);
    }
  }

  async decreaseQuantity(event) {
    document.querySelector('.loader-side-cart').classList.add('loading')
    const parentItem = event.currentTarget.closest(".cart-item__perso");
    if (!parentItem) {
      console.error("Erreur : Élément parent introuvable.");
      return;
    }

    const itemId = parentItem.dataset.id;
    const currentQuantity = parseInt(
      parentItem.querySelector(".span-quantity-perso").innerText
    );

    if (!itemId) {
      console.error("Erreur : ID du produit introuvable.");
      return;
    }

    if (currentQuantity < 1) {
      this.removeItem(item);
      return;
    }

    try {
      const formData = new FormData();
      formData.append("id", itemId);
      formData.append("quantity", currentQuantity - 1);

      const response = await fetch("/cart/change.js", {
        method: "POST",
        body: formData,
      });

      const cart = await response.json();
      this.updateCart(cart);
    } catch (error) {
      console.error("Erreur lors de la diminution de la quantité :", error);
    }
  }

  async updateCart() {
    document.querySelector('.loader-side-cart').classList.add('loading')
    const url = `${window.Shopify.routes.root}?section_id=side-cart`;

    try {
      const response = await fetch(url);
      const html = await response.text();

      const currentCart = document.querySelector("#section-side-cart");
      const wasActive = currentCart.classList.contains("active-sc");

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      const newCart = doc.querySelector("#section-side-cart");
      newCart.querySelector("side-cart").classList.add("active-sc");

      if (currentCart && newCart) {
        currentCart.innerHTML = newCart.innerHTML;

        // Restaurer l'état actif si nécessaire
        if (wasActive) {
          currentCart.classList.add("active-sc");
        }
      }

      const overlay = document.querySelector(".overlay");
      if (overlay) {
        overlay.classList.add("overlay-blur");
      }

      console.log("Panier mis à jour avec succès !");
    } catch (error) {
      console.error("Erreur lors du rendu du panier :", error);
    }
  }
}

customElements.define("side-cart", SideCart);


document.addEventListener("click", function (event) {
  const target = event.target;
  const openButton = document.querySelector("[data-open-cart]");
  const isClickInside = target.closest(".side-cart__container");

  if (!isClickInside && !target.closest("[data-open-cart]")) {
    document.querySelector("side-cart").classList.remove("active-sc");
    document.querySelector(".overlay").classList.remove("overlay-blur");
    document.body.classList.remove("no-scroll");
  }

});


class TabItems extends HTMLElement {
  constructor() {
    super();

    this.querySelectorAll(".faq-item-title").forEach((button) => {
      button.addEventListener("click", this.toggleFaqItem.bind(this));
    });

  }


  toggleFaqItem(e) {
    e.stopPropagation();

    const currentItem = e.currentTarget.parentNode; // Élément cliqué
    const allItems = this.parentNode.querySelectorAll(".faq-item-active"); // Tous les items ouverts

    // Ferme les autres éléments déjà ouverts
    allItems.forEach((item) => {
      if (item !== currentItem) {
        item.classList.remove("faq-item-active");
        item.querySelector('.faq-item-text').slideUp(250);
      }
    });

    const item = currentItem.querySelector(".faq-item-text");
    item.closest(".tabs-section__item").classList.toggle("faq-item-active");
    item.slideToggle(250);
  }
}

customElements.define('tab-items', TabItems);

class VideoSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.init();
    window.addEventListener('load', this.init.bind(this));
  }

  init() {
    this.swiper = new Swiper(this.querySelector('.swiper'), {
      direction: 'horizontal',
      slidesPerView: 1.6,
      spaceBetween: 12,
      loop: false,
      navigation: {
        nextEl: '.custom-swiper-button-next2',
        prevEl: '.custom-swiper-button-prev2',
      },
      breakpoints: {
        750: {
          slidesPerView: 2.5,
          spaceBetween: 14,
        },
        989: {
          slidesPerView: 3.9,
          spaceBetween: 18,
        },
      },
    });

    this.querySelectorAll('.video-overlay-review').forEach((overlayReview) => {
      overlayReview.addEventListener('click', (e) => {
        const videoReview = overlayReview.nextElementSibling;
        overlayReview.style.display = 'none'; // Masque l'overlay
        videoReview.style.display = 'block'; // Affiche la vidéo
        videoReview.setAttribute('controls', true); // Active les contrôles
        videoReview.play(); // Démarre la lecture
      });
    });

    // this.querySelectorAll('video').forEach((video) => {
    //   video.addEventListener('pause', () => {
    //     video.style.display = 'none'; // Cacher la vidéo
    //     video.previousElementSibling.style.display = 'block'; // Afficher l'overlay
    //   });
    // });
  }
}

customElements.define('video-slider', VideoSlider);

class CommentSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    window.addEventListener('load', this.init.bind(this));
  }

  init() {
      this.swiper = new Swiper(this.querySelector('.swiper-comment'), {
      direction: 'horizontal',
      slidesPerView: 'auto',
      loop: false,
      slidesOffsetAfter: 60,
      });
  }
}

customElements.define('comment-slider', CommentSlider);